export const GameStatusTypes = {
    ALL: {
        title: "همه",
        id: "All"
    },
    PUBLISHED: {
        title: "منتشر شده",
        id: "PUBLISHED"
    },
    DRAFT: {
        title: "پیش نویس",
        id: "DRAFT"
    },
    ARCHIVED: {
        title: "بایگانی شده",
        id: "ARCHIVED"
    },
    SUSPENDED: {
        title: "معلق شده",
        id: "SUSPENDED"
    }
}

export function getGameStatus(status) {

    switch (status) {

        case GameStatusTypes.PUBLISHED.id: {
            return GameStatusTypes.PUBLISHED.title
        }
        case GameStatusTypes.DRAFT.id: {
            return GameStatusTypes.DRAFT.title
        }
        case GameStatusTypes.ARCHIVED.id: {
            return GameStatusTypes.ARCHIVED.title
        }
        case GameStatusTypes.SUSPENDED.id: {
            return GameStatusTypes.SUSPENDED.title
        }

    }

}
